import React from "react";
import bannerImg from "../assets/images/tearmbanner.png";
const Termsandconditions = () => {
    return (
        <div>
         <section className="home-main-sec ">

<img src={bannerImg} className="home-main-sec-bg" alt="Banner" />

<div className="home-main-sec-overlay"></div>

<div className="container home-main-sec-content">

  <h1 className="loop-title">
 Rooted in belief, guided by sacred values
  </h1>



</div>

</section>













<section className="terms-page-section">
      <div className="terms-page-container">

        <div className="terms-page-header">
          <p className="terms-page-title">Terms and Conditions</p>
          <p className="terms-page-updated">
            {/* Last Updated: <span>January 2026</span> */}
          </p>
        </div>

        <div className="terms-page-content">

          <p className="terms-page-intro">
            Welcome to <strong>TheOmSaga</strong> (“Platform”, “we”, “our”, “us”). 
            By accessing or using this website, you agree to comply with and be bound by 
            the following Terms and Conditions (“Terms”). If you do not agree, please 
            discontinue use of the Platform.
          </p>

          <div className="terms-page-block">
            <p className="terms-page-heading">1. Purpose of the Platform</p>
            <p className="terms-page-text">
            TheOmSaga is a global storytelling platform that allows individuals 
              to share personal, real-life spiritual experiences, beliefs, and reflections 
              related to Hindu gods and goddesses. The Platform is intended for spiritual, 
              cultural, and experiential sharing only.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">2. User Eligibility</p>
            <p className="terms-page-text">
              Users must be at least 18 years old to submit content and must comply with 
              the laws applicable in their country of residence.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">3. Nature of Content & Disclaimer</p>
            <p className="terms-page-text">
              All content shared reflects personal beliefs and experiences. The Platform 
              does not verify or validate spiritual claims and does not provide religious, 
              medical, legal, or professional advice.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">4. Content Submission Guidelines</p>
            <p className="terms-page-text">
              Submitted content must be original, respectful, non-offensive, and must not 
              infringe on third-party rights. We reserve the right to review, edit, or remove 
              content.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">5. Religious & Cultural Sensitivity</p>
            <p className="terms-page-text">
              Content must maintain respect toward Hindu gods, goddesses, traditions, and 
              devotees. Disrespectful or inflammatory content will not be permitted.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">6. Intellectual Property</p>
            <p className="terms-page-text">
              Authors retain ownership of their content. By submitting content, users grant 
              the Platform a non-exclusive, royalty-free, worldwide license to publish and 
              distribute the content with appropriate credit.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">7. Anonymity & Privacy</p>
            <p className="terms-page-text">
              Users may choose to remain anonymous. Any personal information shared is at 
              the user’s discretion.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">8. Moderation & Removal</p>
            <p className="terms-page-text">
              We reserve the right to remove content or restrict access without notice if 
              these Terms are violated.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">9. Limitation of Liability</p>
            <p className="terms-page-text">
              The Platform is provided “as is”. We are not liable for any damages arising 
              from use of the Platform or reliance on shared content.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">10. Governing Law</p>
            <p className="terms-page-text">
              These Terms are governed by the laws of <strong>India</strong>. 
              Any disputes shall be subject to the jurisdiction of the courts of 
              <strong> Bangalore, India</strong>.
            </p>
          </div>

          <div className="terms-page-block">
            <p className="terms-page-heading">11. Contact</p>
            <p className="terms-page-text">
              For queries, contact us at <strong>info@theomsaga.com</strong>.
            </p>
          </div>

        </div>
      </div>
    </section>
        </div>
    )
}
export default Termsandconditions;